import script from "./hotTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./hotTemplate.vue?vue&type=script&setup=true&lang=js"

import "./hotTemplate.vue?vue&type=style&index=0&id=4aa6f0e3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aa6f0e3"]])

export default __exports__